import React from "react";
import { styled } from "@mui/system";
import Box from "@mui/material/Box";

const ShimmerWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  width: "100%",
  padding: theme.spacing(2),
  backgroundColor: "#F9F9F9",
}));

const ShimmerTable = styled(Box)({
  display: "grid",
  gap: "16px",
});

const ShimmerRow = styled(Box)({
  display: "flex",
  gap: "16px",
});

const ShimmerCell = styled(Box)(({ theme }) => ({
  flex: 1,
  height: "30px",
  backgroundColor: "#E0E0E0",
  borderRadius: "12px",
  overflow: "hidden",
  position: "relative",
  // Shimmer effect
  "&::before": {
    content: '""',
    display: "block",
    position: "absolute",
    top: 0,
    left: "-150%",
    height: "100%",
    width: "150%",
    background: `linear-gradient(90deg, 
      rgba(240, 240, 240, 0.2) 0%, 
      rgba(255, 255, 255, 0.5) 50%, 
      rgba(240, 240, 240, 0.2) 100%)`,
    animation: "shimmer 1.5s infinite",
  },
  "@keyframes shimmer": {
    "0%": {
      transform: "translateX(-100%)",
    },
    "100%": {
      transform: "translateX(100%)",
    },
  },
}));

const ShimmerTableComponent = () => {
  return (
    <ShimmerWrapper>
      <ShimmerTable>
        {[...Array(5)].map((_, index) => (
          <ShimmerRow key={index}>
            {[...Array(4)].map((__, cellIndex) => (
              <ShimmerCell key={cellIndex} />
            ))}
          </ShimmerRow>
        ))}
      </ShimmerTable>
    </ShimmerWrapper>
  );
};

export default ShimmerTableComponent;
